













import { Component, Vue, Prop } from 'vue-property-decorator'
import IToggleOption from '@/store/interface/IToggleOption'

/**
 * Toggler - component responsible for rendering toggle according to passed
 * props. Basically this component wraps quasar native button toggler, and
 * manages the translations depending on the passed properties.
 */
@Component({
	name: 'Toggler'
})
export default class Toggler extends Vue {
	@Prop()
	private variation!: IToggleOption[]
	@Prop({ default: '' })
	private chosenOption!: string | boolean
	@Prop({ default: false })
	private isDisabled!: boolean

	// Computes translated options
	public get translatedOptions (): IToggleOption[] {
		return this.variation.map((el: IToggleOption) => {
			// Checks if the text is translated already, to avoid extra translation
			if (el.label.indexOf('.') !== -1) {
				el.label = `${this.$t(el.label)}`
			}

			return el
		})
	}

	// Emits value to parent component
	private onInput (val: string): void {
		this.$emit('toggleChange', val)
	}
}
